// extracted by mini-css-extract-plugin
module.exports = {"filtersPanel":"UserPermissionsList__filtersPanel___gM3Iy"};